import * as actionTypes from './types';

const INITIAL_STATE = {
  current: null,
  result: null,
  resultReviews: null
};

const activeReducer = (state = INITIAL_STATE, action) => {
  const { payload = null } = action;
  switch (action.type) {
    case actionTypes.SET_ACTIVE:
      return {
        ...state,
        current: action.payload,
      };
    case actionTypes.RESET_STATE:
      return INITIAL_STATE;

    case actionTypes.RESET_STATE:
      return INITIAL_STATE;
    case actionTypes.REQUEST_LOADING:
      return {
        ...state,
        isLoading: true,
      };
    case actionTypes.REQUEST_FAILED:
      return {
        ...state,
        isLoading: false,
        isSuccess: false,
      };
    case actionTypes.REQUEST_SUCCESS:
      return {
        result: payload,
        isLoading: false,
        isSuccess: true,
      };
    case actionTypes.REQUEST_SUCCESS_REVIEWS:
      return {
        resultReviews: payload,
        isLoading: false,
        isSuccess: true,
      };
    default:
      return state;
  }
};

export default activeReducer;